import { LOANREQUEST_BUCKETS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    position?: number;
};
export const schemaLoanRequestResolver_GetBucketCounts = z.array(
    z.object({ count: z.number(), name: z.nativeEnum(LOANREQUEST_BUCKETS) }),
);

export type SchemaLoanRequestResolver_GetBucketCounts = z.infer<typeof schemaLoanRequestResolver_GetBucketCounts>;

export type LoanRequestResolver_GetBucketCounts = Resolver<Arguments, SchemaLoanRequestResolver_GetBucketCounts>;
